/**
 * Renders the cross-sell section at checkout, before the booking is completed
 * (TRAV23-4681). Off in every environment: the section belongs on the confirmation
 * page, and this exists only so the recommendations can be exercised without paying
 * for a booking. Set via `VITE_CROSS_SELL_AT_CHECKOUT` in `.env.*` (boolean string
 * `true` / `false`).
 */
export const CROSS_SELL_AT_CHECKOUT = import.meta.env.VITE_CROSS_SELL_AT_CHECKOUT === 'true';
